import React from 'react';

import { AlertContainer, AlertContent, IconSlot } from './style';

export interface AlertProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
  variant?: 'outlined' | 'ghost';
  severity?: 'info' | 'success' | 'warning' | 'error';
  sx?: React.CSSProperties;
}

const Alert = (props: AlertProps) => {
  const { icon, variant = 'ghost', severity = 'info', sx, children, ...rest } = props;

  return (
    <AlertContainer variant={variant} severity={severity} style={sx} {...rest}>
      {icon ? <IconSlot>{icon}</IconSlot> : null}

      <AlertContent>{children}</AlertContent>
    </AlertContainer>
  );
};

export { AlertTitle } from './style';
export default Alert;
